import {
  cancelReasonDefaultOptions,
  reasonDefaultOptions,
} from 'common/constants';

export interface IDashboard {
  totalPaid: number;
  totalCostOfPurchase: number;
  totalCostOfShipping: number;
  totalFees: number;
  totalMargin: number;
  amountOfOrders: number;
  amountOfShipments: number;
  amountOfCustomers: number;
  cancellations: {
    byReason: Partial<
      Record<(typeof cancelReasonDefaultOptions)[number]['value'], number>
    >;
    totalAmount: number;
  };
  refunds: {
    byReason: Partial<
      Record<(typeof reasonDefaultOptions)[number]['value'], number>
    >;
    totalAmount: number;
  };
}

export interface ISectionItem {
  label: string;
  value?: string | number;
}

export interface IDataPoint {
  period: string;
  value: number;
}

export interface IChartData {
  dataPoints: IDataPoint[];
}

export const Interval = ['DAY', 'WEEK', 'MONTH'] as const;
export const Metric = ['ORDERS', 'REVENUE', 'MARGIN'] as const;

export type TInterval = (typeof Interval)[number];
export type TMetric = (typeof Metric)[number];

export interface IGetChartDataOptions {
  startDate: string;
  endDate: string;
  metric: TMetric;
  interval: TInterval;
}
